import React from "react";
import { withRouter } from "react-router-dom";

import AuthUserContext from "./AuthUserContext";
import { firebase } from "../firebase";
import * as routes from "../constants/routes";

const withAuthorization = authCondition => Component => {
  class WithAuthorization extends React.Component {
    componentDidMount() {
      //     it uses the Firebase listener to trigger a callback function in case the authenticated user
      // object changes. Every time the authUser changes, it checks the passed authCondition() function
      // with the authUser. If the authorization fails, the higher order component redirects to the sign in
      // page. If it doesn’t fail, the higher order component does nothing. In order to be able to redirect,
      // the higher order component has access to the history object of the Router by using the in-house
      // withRouter() higher order component from the React Router library.

      firebase.auth.onAuthStateChanged(authUser => {
        if (!authCondition(authUser)) {
          // If the authorization fails, the higher order component redirects to the sign in page.
          this.props.history.push(routes.SIGN_IN);
          // In order to be able to redirect, 
          // the higher order component has access to the history object 
          // of the Router by using the in-house withRouter() higher order 
          // component from the React Router library.
        }
        // If it doesn’t fail, the higher order component does nothing.
      });
    }

    render() {
      return (
        <AuthUserContext.Consumer>
          {/* It renders either the passed com ponent (e.g. HomePage,
          AccountPage) or nothing. That’s just a fallback in case there is no
          authenticated user passed by the Consumer component from React’s
          context object.  */}
          {authUser => (authUser ? <Component aa={authUser} /> : null)}
        </AuthUserContext.Consumer>
      );
    }
  }

  return withRouter(WithAuthorization);
};

export default withAuthorization;
